module.exports = __webpack_public_path__ + "static/media/misstag.23fdba3b.mp3";